module.exports = __webpack_public_path__ + "static/img/part2.4e0ae51.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/part2.png
// module id = dGaf
// module chunks = 9